import {StopSource} from "./stop.source.mjs";
import {DestinationIndexSource} from "./destinationindex.source.mjs";
import {ItineraryIndexSource} from "./itineraryindex.source.mjs";
import {BanSource} from "./ban.source.mjs";


export var destinationIndexSource = (()=>{
    return new DestinationIndexSource();
})();

export var itineraryIndexSource = (()=>{
    return new ItineraryIndexSource();
})();


export var schoolSource = (()=>{ 
    function getItems(data){ return data.items }
    function getDest(dataArr){ 
        return dataArr.map(data => data.destination) 
    }
    return new StopSource(destinationIndexSource, 'schoolsource', [getItems, getDest]);
})();

export var homeSource = (()=>{ 
    /* function getStations(itinearyIndex){ return itinearyIndex.getStations() }  */
    function getStations(itineraryIndex){ 
        var stations = itineraryIndex.getStations();
        stations =  [ itineraryIndex.getDestination()].concat(stations)
        return stations; 
    }
    var homeSource = new StopSource(itineraryIndexSource, 'homesource', [getStations]);
    return homeSource;
})();

export var banSource = (()=>{
    return new BanSource();
})();

